function UtcToTimezone(datetime, format) {
  const utcIsoString = datetime.replace(' ', 'T') + 'Z';

  return new Date(utcIsoString);
}

export default UtcToTimezone;
